module.exports = __webpack_public_path__ + "static/works-psdwizard-cbcf01edd34bdcac7ccc05b437609176.jpg";